import react from 'react'
import './App.css';
import Quotes from './components/Quotes';
import Clock from './Clock';

function App() {
  return (
    <div className = "App" >
    
      <Quotes/>
    </div>
  )
   
}

export default App;

